var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    fill: "#86888c",
    r: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.18 23.91h-13.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.91 23.91h-1.91a1.16 1.16 0 0 1 -1-.66l-.48-.94a4.76 4.76 0 0 1 -.52-2.13 4.71 4.71 0 0 1 .8-2.68l1.81-2.71c.22-.45.82-1.31 1.25-1.31h13.87a1.24 1.24 0 0 1 .92.38l3.23 3.24a1.21 1.21 0 0 0 .71.36l6.16 1.29a1.53 1.53 0 0 1 1.25 1.25v2.71a1.25 1.25 0 0 1 -1.19 1.29h-1.42"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.51,
    cy: 23.91,
    r: 2.61
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.78,
    cy: 23.91,
    r: 2.61
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.663ede8524a41c6607f1426f0319af94.svg";
export { ForwardRef as ReactComponent };